export default __webpack_public_path__ + "static/media/material-ui.741a52f5.svg";